import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const fillDetail = () => {
  $("#d-algemeen-gisratio").html(window.$mm_schedule_selectedRow.algemeenGisratio);
  $("#d-status").html(window.$mm_schedule_selectedRow.status);
  $("#d-maatregel-naam").html(window.$mm_schedule_selectedRow.maatregelNaam);
  $("#d-werkplan-naam").html(window.$mm_schedule_selectedRow.werkplanNaam);
  $("#d-planningspatroon-naam").html(
    window.$mm_schedule_selectedRow.planningspatroonNaam
  );
  $("#d-planningsperiode-naam").html(
    window.$mm_schedule_selectedRow.planningsperiodeNaam
  );
  $("#d-budget-naam").html(window.$mm_schedule_selectedRow.budgetNaam);
  $("#d-beheereenheid-naam").html(window.$mm_schedule_selectedRow.beheereenheidNaam);
  $("#d-beheeractiviteit-laag").html(
    window.$mm_schedule_selectedRow.beheeractiviteitLaag
  );
  $("#d-discipline-naam").html(window.$mm_schedule_selectedRow.disciplineNaam);
  $("#d-status-tijdstip_verzonden").html(
    window.$mm_schedule_selectedRow.statusTijdstipVerzonden
  );
};

export function GetColumnProperties(callType) {}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {}


export async function DefinationStatus() {
  var model = {
    definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    query: {
      definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    },
  };
  let result = await omnimap.GetDefinationStatusAction(
    model,
    window.$mm_management_units_token
  );

  if (result.data !== undefined) {
    result.data.forEach((element) => {
      window.$mm_schedule_plannigStatus.push(element.status);
    });
  }
}